import script from "./MessageExamplesContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageExamplesContent.vue?vue&type=script&setup=true&lang=js"

import "./MessageExamplesContent.vue?vue&type=style&index=0&id=100cfd00&lang=css"

const __exports__ = script;

export default __exports__